import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export default function TagSchemaChip(props: SharedSmartChipProps<SmartChipType.TAG_SCHEMA>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: tagSchema,
    handleClickLink,
    isInaccessible,
  } = useSmartChipQuery<SmartChipType.TAG_SCHEMA>({
    id,
    onClick,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={(tagSchema?.iconId as BenchlingIconName) ?? null}
      isInaccessible={isInaccessible}
      item={tagSchema}
      onClick={handleClickLink}
      url={null}
    />
  );
}
